const initialState = {
  profileData: {},
  profileImage: null,
  mobileAppSettingsMasterList: [],
  appModules: {},
  eventTypeList: [],
  abnormalMotionEvent: {},
  patientSubscription: null,
  contactAlertLimit: null,
  geoLocationSettings: {},
  safeLocationAlerts: {}
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */
const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PATIENT_PROFILE_DATA":
      return { ...state, profileData: action.payload.profileData };

    case "SET_PATIENT_PROFILE_IMAGE":
      return { ...state, profileImage: action.payload.profileImage };

    case "SET_MOBILE_APP_SETTINGS_MASTER_LIST":
      return {
        ...state,
        mobileAppSettingsMasterList: action.payload.mobileAppSettingsMasterList,
      };

    case "SET_CONTACT_ALERT_LIMIT":
      return {
        ...state,
        contactAlertLimit: action.payload.contactAlertLimit,
      };

    case "SET_APP_MODULES":
      return {
        ...state,
        appModules: action.payload.appModules,
      };

    case "SET_EVENT_TYPES":
      return {
        ...state,
        eventTypeList: action.payload.eventTypeList,
      };

    case "SET_AM_EVENT_DATA":
      return {
        ...state,
        abnormalMotionEvent: action.payload.abnormalMotionEvent,
      };
    case "SET_UNPLANNED_MEDICAL_VISIT_EVENT_DATA":
      return {
        ...state,
        unplannedMedicalVisit: action.payload.unplannedMedicalVisit,
      };
    case "SET_CURRENT_MEDICATIONS_DATA":
      return {
        ...state,
        currentMedications: action.payload.currentMedications,
      };
    case "SET_SAFE_LOCATION_ALERTS_DATA":
      return {
        ...state,
        safeLocationAlerts: action.payload.safeLocationAlerts,
      };
    case "SET_MEDICATION_ADHERENCE_DATA":
      return {
        ...state,
        medicationAdherence: action.payload.medicationAdherence,
      };
    case "SET_PATIENT_SUBSCRIPTION":
      return {
        ...state,
        patientSubscription: action.payload.patientSubscription,
      };
    case "SET_SYMPTOMS_DATA":
      return {
        ...state,
        symptoms: action.payload.symptoms,
      };
    case "SET_HRM_DATA":
      return {
        ...state,
        hrm: action.payload.hrm,
      };
    case "SET_HRM_DATA":
      return {
        ...state,
        hrm: action.payload.hrm,
      };
    case "SET_FALL_DATA":
      return {
        ...state,
        fallEvent: action.payload.fallEvent,
      };
    case "SET_HELP_DATA":
      return {
        ...state,
        help: action.payload.help,
      };
    case "SET_GEO_LOCATION_SETTINGS":
      return { ...state, geoLocationSettings: action.payload.geoLocationSettings };

    case "RESET_DASHBOARD_DATA":
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default dashboardReducer;
